/* istanbul ignore file */

export const MODAL_CONTROLS_CLOSE = 'Close';
export const MODAL_HEADING = 'Filter & Sort';
export const NO_MATCHING_PRODUCTS = 'No matching products';
